<template>
  <div
    v-if="idModal === 0"
    ref="kt_modal_cliente_telefones"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_cliente_telefones"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/electronics/elc003.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Telefones</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('exibirModalCliente', false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <table
            :class="[loading && 'overlay overlay-block']"
            v-if="this.cliente && this.cliente.ClienteTelefone"
            class="table align-middle table-row-dashed fs-6 text-gray-600 fw-bold gy-5 table-hover"
            id="kt_table_telefones"
          >
            <tbody>
              <template
                v-for="(telefone, i) in this.cliente.ClienteTelefone"
                :key="i"
              >
                <tr>
                  <td class="ps-5">
                    {{ telefone.descricao + ": " }}
                  </td>
                  <td class="min-w-150px">
                    {{ telefone.telefone }}
                  </td>
                  <td class="pe-5 text-end">
                    <button
                      class="btn btn-sm btn-light-primary"
                      data-bs-dismiss="modal"
                      @click="
                        this.$emit('selecionarTelefone', telefone.telefone)
                      "
                    >
                      Selecionar
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
            <div
              v-if="loading"
              class="overlay-layer card-rounded bg-dark bg-opacity-5"
            >
              <div class="spinner-border text-primary" role="status"></div>
              <span class="ms-2">Aguarde, carregando...</span>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="idModal === 1"
    ref="kt_modal_cliente_emails"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_cliente_emails"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/communication/com011.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Emails</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('exibirModalCliente', false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <table
            :class="[loading && 'overlay overlay-block']"
            v-if="this.cliente && this.cliente.ClienteEmail"
            class="table align-middle table-row-dashed fs-6 text-gray-600 fw-bold gy-5 table-hover"
            id="kt_table_emails"
          >
            <tbody>
              <template
                v-for="(email, i) in this.cliente.ClienteEmail"
                :key="i"
              >
                <tr>
                  <td class="ps-5">
                    {{ email.descricao + ": " }}
                  </td>
                  <td class="min-w-250px">
                    {{ email.email }}
                  </td>
                  <td class="pe-5 text-end">
                    <button
                      class="btn btn-sm btn-light-primary"
                      data-bs-dismiss="modal"
                      @click="this.$emit('selecionarEmail', email.email)"
                    >
                      Selecionar
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
            <div
              v-if="loading"
              class="overlay-layer card-rounded bg-dark bg-opacity-5"
            >
              <div class="spinner-border text-primary" role="status"></div>
              <span class="ms-2">Aguarde, carregando...</span>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="idModal === 2"
    ref="kt_modal_cliente_enderecos"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_cliente_enderecos"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/communication/com005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Endereços</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('exibirModalCliente', false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <table
            :class="[loading && 'overlay overlay-block']"
            v-if="this.cliente && this.cliente.ClienteEndereco"
            class="table align-middle table-row-dashed fs-6 text-gray-600 fw-bold gy-5 table-hover"
            id="kt_table_enderecos"
          >
            <tbody>
              <template
                v-for="(endereco, i) in this.cliente.ClienteEndereco"
                :key="i"
              >
                <tr>
                  <td class="ps-5">
                    {{ endereco.descricao + ": " }}
                  </td>
                  <td>
                    <div class="min-w-350px align-middle">
                      <div>
                        <span class="text-dark text-hover-primary mb-1">
                          {{
                            endereco.endereco +
                            ", " +
                            endereco.numero +
                            " - " +
                            endereco.bairro +
                            " - " +
                            endereco.cidade +
                            " - " +
                            endereco.uf
                          }}
                        </span>
                        <span class="text-muted fw-bold d-block">
                          {{ endereco.complemento + " CEP: " + endereco.cep }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td class="pe-5 text-end">
                    <button
                      class="btn btn-sm btn-light-primary"
                      data-bs-dismiss="modal"
                      @click="this.$emit('selecionarEndereco', endereco)"
                    >
                      Selecionar
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
            <div
              v-if="loading"
              class="overlay-layer card-rounded bg-dark bg-opacity-5"
            >
              <div class="spinner-border text-primary" role="status"></div>
              <span class="ms-2">Aguarde, carregando...</span>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: [
    "selecionarTelefone",
    "selecionarEmail",
    "selecionarEndereco",
    "exibirModalCliente",
  ],
  components: {},
  props: {
    idCliente: { type: Number, required: true, default: 0 },
    idModal: { type: Number, required: true, default: 0 },
  },
  methods: {
    async carregarCliente() {
      this.loading = true;
      try {
        var ret = await this.$store.dispatch(
          "cliente/getCliente",
          this.idCliente
        );
        if (ret.Success === true) {
          this.cliente = ret.Data;
        }
      } catch (error) {
        toast.error("Não foi possível consultar o cliente!", { timeout: 2000 });
      }
      this.loading = false;
    },
  },
  mounted() {
    this.carregarCliente();
  },
  data() {
    return {
      loading: false,
      cliente: null,
    };
  },
};
</script>

<style></style>
